import React from 'react';
import { useParams } from 'react-router';
import CareersBrandHeader from './CareersBrandHeader';

/**
 * The bar above a job: the organization's own, not the product's.
 *
 * The address carries the organization's slug, which is the cheaper thing to ask
 * about, and the job id is the way in for any address that does not.
 */
const CareerDetailsHeader = () => {
  const { slug, id } = useParams();
  return <CareersBrandHeader slug={slug} jobId={slug ? undefined : id} context="Career details" />;
};

export default CareerDetailsHeader;
